import { render, staticRenderFns } from "./Bracket64.vue?vue&type=template&id=368807f0&"
import script from "./Bracket64.vue?vue&type=script&lang=js&"
export * from "./Bracket64.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports